export const ReusableWorkSection = () => {
    return (
        <>
        
            <section className="works-section" id="work_sec1">
                <div className="container">
                    <div className="row pt-4  ">

                        <h1 className="mb-3 mt-4 " style={{ textAlign: 'left' }}>How it <span style={{ color: '#00675B' }}>Works</span></h1>
                        <p id="work1" style={{ textAlign: 'left' }}>See the simple steps to explore, discover, and utilize our code repositories</p>
                        <div className="container_1 mb-4">

                            <div className="step">
                                <h1>01</h1>
                                <span className="number">01</span>
                                <div className="circle"></div>
                                <h2   style={{color: '#00675B', fontSize: '20px', fontWeight: 700}}>Browse Repositories</h2>
                                <p>Explore a wide range of publicly shared code</p>
                            </div>

                            <div className="step">
                                <h1>02</h1>
                                <span className="number">02</span>
                                <div className="circle"></div>
                                <h2 style={{color: '#00675B', fontSize: '20px', fontWeight: 700}}>Discover Detail</h2>
                                <p> Learn about each repository's purpose and contents</p>
                            </div>

                            <div className="step">
                                <h1>03</h1>
                                <span className="number">03</span>
                                <div className="circle"></div>
                                <h2 style={{color: '#00675B', fontSize: '20px', fontWeight: 700}}>Download Code</h2>
                                <p>Get the repository files with a simple click</p>
                            </div>

                            <div className="step">
                                <h1>04</h1>
                                <span className="number">04</span>
                                <div className="circle"></div>
                                <h2 style={{color: '#00675B', fontSize: '20px', fontWeight: 700}}>Utilize the Code</h2>
                                <p>Integrate and learn from the downloaded resources</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="works-section" id="work_sec2">
                <div className="container steps-section">
                    <h2>How it <span className="highlight">Works</span></h2>
                    <p className="title_1">See the simple steps to explore, discover, and utilize our code repositories</p>

                    <div className="steps-row">
                        <div className="step-box">
                            <div className="step-number">01</div>
                            <div className="step-content">
                                <p className="step-title">Browse Repositories</p>
                                <p className="step-description">Explore a wide range of publicly shared code</p>
                            </div>
                        </div>

                        <div className="step-box">
                            <div className="step-number">02</div>
                            <div className="step-content">
                                <p className="step-title">Discover Details</p>
                                <p className="step-description">Learn about each repository's purpose and contents</p>
                            </div>
                        </div>

                        <div className="step-box">
                            <div className="step-number">03</div>
                            <div className="step-content">
                                <p className="step-title">Download Code</p>
                                <p className="step-description">Get the repository files with a simple click</p>
                            </div>
                        </div>


                        <div className="step-box">
                            <div className="step-number" id="step_41">04</div>
                            <div className="step-content">
                                <p className="step-title">Utilize the Code</p>
                                <p className="step-description">Integrate and learn from the downloaded resources.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}